var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.judgeBox),expression:"judgeBox"}],staticClass:"painterBtn"},[_c('div',{staticClass:"submit",class:{disabled: _vm.btnDisabled},on:{"click":function($event){return _vm.propsEvent('submit')}}},[_vm._v("\n      提交审核\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c65bc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav/exportDialog/painterBtn.vue
// module id = null
// module chunks = 